import { Controller } from "@hotwired/stimulus"

// Client-side filter for the organization Members table. The member list is
// small and fully rendered, so search / access / role filtering just toggles
// row visibility in place — no server round-trip.
export default class extends Controller {
  static targets = ["query", "row", "accessChip", "roleChip", "empty"]

  connect() {
    this.query = ""
    this.access = "all"
    this.role = "all"
    this.render()
  }

  search() {
    this.query = (this.queryTarget.value || "").trim().toLowerCase()
    this.render()
  }

  setAccess(event) {
    this.access = event.currentTarget.dataset.access || "all"
    this.highlight(this.accessChipTargets, event.currentTarget)
    this.render()
  }

  setRole(event) {
    this.role = event.currentTarget.dataset.role || "all"
    this.highlight(this.roleChipTargets, event.currentTarget)
    this.render()
  }

  highlight(chips, active) {
    chips.forEach((chip) => {
      const on = chip === active
      chip.classList.toggle("btn-primary", on)
      chip.classList.toggle("btn-outline", !on)
    })
  }

  render() {
    let visible = 0
    this.rowTargets.forEach((row) => {
      const matches =
        (this.access === "all" || row.dataset.access === this.access) &&
        (this.role === "all" || row.dataset.role === this.role) &&
        (this.query === "" || (row.dataset.search || "").includes(this.query))
      row.hidden = !matches
      if (matches) visible += 1
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0
  }
}
